const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getUserToken = () => {
  let token = localStorage.getItem('ris_user_token');
  if (!token) {
    token = 'usr_' + crypto.randomUUID();
    localStorage.setItem('ris_user_token', token);
  }
  return token;
};

const COVER_IMAGE = "https://customer-assets.emergentagent.com/job_script-executor-lab/artifacts/5lcbgepp_mm4ibs0i524clw.jpeg";
const ALBUM_COVER = `${BACKEND_URL}/api/files/album-cover`;
const STUDIO_LOGO = `${BACKEND_URL}/api/files/logo`;
const LOGO_CDN = "https://customer-assets.emergentagent.com/job_53d01eed-6d83-4a7b-9b59-4f2d71e2f14c/artifacts/8ph1hc85_RED%20INK%20LOGO.jpeg";
const SSB_PLACEHOLDER = "https://static.prod-images.emergentagent.com/jobs/830180d3-dce1-4757-aa41-278abb909468/images/1b19fe007df373e5b8f353546853fc07a45f43883eb85338f6e665a201db1683.png";

export { BACKEND_URL, API, getUserToken, COVER_IMAGE, ALBUM_COVER, STUDIO_LOGO, LOGO_CDN, SSB_PLACEHOLDER };
